<template>
  <section class="section">
    <HeadingBlock :content="content" class="section__content --centered" />
    <div class="activity__card-container">
      <div class="activity__card-button-container">
        <ul
          class="activity__card-group"
          v-if="activities.length"
          v-reveal="{ delay: 250 }"
          ref="activities"
        >
          <ActivityCard :activity="activity" v-for="activity in activities" :key="activity.id" />
        </ul>
        <Transition name="fade">
          <div v-if="mq.mdPlus && activities.length > 3">
            <button
              class="activity__card-button"
              v-for="index in 2"
              :key="index"
              :disabled="isDisabled(currentScrollStep, index)"
              @click="updateCurrentStep(index)"
              :title="index === 0 ? $t('previous') : $t('next')"
            >
              <Icon id="arrow-long" />
            </button>
          </div>
        </Transition>
      </div>
    </div>
    <div class="section__content">
      <NoteBlock v-if="content.note.length" :content="content.note[0]" v-reveal="{ delay: 250 }" />
    </div>
    <LangRouterLink
      :to="{ name: 'activities' }"
      class="button --big-top --centered"
      v-reveal="{ delay: 300 }"
      >{{ $t('activities.explore') }}</LangRouterLink
    >
  </section>
</template>

<script>
import { HeadingBlock, NoteBlock } from '@/components/blocks'
import { ActivityCard } from '@/components/cards'
import { Icon, LangRouterLink } from '@/components/global'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'CategoryActivitiesSection',
  mixins: [DefaultSectionProps],
  inject: ['mq'],
  components: { ActivityCard, HeadingBlock, Icon, LangRouterLink, NoteBlock },
  data() {
    return {
      currentScrollStep: 0,
    }
  },
  computed: {
    activities() {
      if (!this.$route.name.includes('category')) return []

      const categoryID = this.$store.getters.categoriesSlugMap[this.$route.params.slug]
      if (!categoryID) return []

      return this.$store.state.activities.filteredByCategory[categoryID] ?? []
    },
  },
  methods: {
    isDisabled(step, index) {
      if (index === 1) return step === 0
      return this.activities.length <= 3 || step === this.activities.length - 3
    },
    updateCurrentStep(index) {
      if (index === 1 && this.currentScrollStep > 0) this.currentScrollStep--
      else if (index === 2 && this.currentScrollStep < this.activities.length - 3)
        this.currentScrollStep++
    },
  },
  watch: {
    currentScrollStep() {
      this.$refs.activities.scrollTo({
        left: this.$refs.activities.children[0].offsetWidth * this.currentScrollStep,
        behavior: 'smooth',
      })
    },
  },
}
</script>
